module.exports = __webpack_public_path__ + "static/img/lan01.d08fc36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lan01.png
// module id = 1145
// module chunks = 1